export function htmlShowsPaymentReceivedPage(html) {
    return typeof html === 'string' && html.includes('payment-received-page');
}
